<template>
  <div class="menu">
    <div class="container">
      <a href="#"><div class="menu__logo"></div></a>

<!--       <nav class="menu__items" :class="[ menuExpanded ? 'expanded' : '' ]">
        <a class="item">Home</a>
        <a class="item">Content</a>
        <a class="item">About</a>
        <a class="item">Contact Us</a>
      </nav> -->

      <!-- <div class="menu__burger-button" @click="menuExpanded = !menuExpanded">&#9776;</div> -->

      <div class="lang-buttons">
        <button name="lang-lv" :class="[locale == 'lv' ? 'active' : '']" @click="setLocale('lv')">LV</button>
        <button name="lang-en" :class="[locale == 'en' ? 'active' : '']" @click="setLocale('en')">EN</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationMenu',
  data () {
    return {
      menuExpanded: false,
    }
  },
  props: {
    msg: String,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    store() {
      return this.$root.$data;
    },
    setLocale: function(lang) {
      this.$i18n.locale = lang;
      this.store().changeLanguage(lang);
    }
  }
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'

.menu
  position fixed
  width 100%
  height 90px
  top 0px
  left 0px
  background-color $OTSnavBlue
  color #fff
  z-index 5
  &__logo
    float left
    background-image url('../../assets/logo.png')
    background-size contain
    background-repeat no-repeat
    background-position center center
    width 242px
    height 100%
    +mobileXS()
      width 200px
  &__burger-button
    display block
    position absolute
    top 12px
    right 10px
    font-size 24px
  &__items
    float right
    white-space nowrap
    list-style-type none
    padding 0
    overflow hidden
    margin-top 50px
    max-height 0px
    background-color darken(indianred, 20%)
    &.expanded
      max-height 200px
      transition max-height 0.3s ease
    .item
      display inline-block
      margin 10px 10px
  .lang-buttons
    display inline-block
    float right
    right 0px
    height 100%
    vertical-align middle
    button
      position relative
      top 50%
      transform translate(0%, -50%);
      background-color transparent
      color #fff
      border none
      padding 2px 10px
      opacity 0.6
      &:hover,
      &.active
        opacity 1
    +mobile()
      margin-right 10px

.lang-en
  .menu
    &__logo
      background-image url('../../assets/logoEN.png')
      width 284px
      +mobileXS()
        width 220px
@media screen and (min-width 400px)
  .menu
    &__burger-button
      display none
    &__items
      margin-top 0px
      max-height 50px
      .item
        display inline-block
        margin 16px 10px
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/NavigationMenu.vue